import { selectComplianceEnabled, selectHasAnyTaskManagementBp } from 'features/auth/ducks/selectors'

export const REQUIREMENTS = {
  taskManagement: {
    check: state => !!selectHasAnyTaskManagementBp(state),
    reason: 'Needs task management, which is not switched on for your buildings yet.',
  },
  compliance: {
    check: state => !!selectComplianceEnabled(state) && !!selectHasAnyTaskManagementBp(state),
    reason: 'Needs compliance and task management, which are not both switched on for your account yet.',
  },
}

export const availabilityOf = (workflow, state, { hasBuildings = true } = {}) => {
  if (workflow?.needs?.building && !hasBuildings) {
    return { available: false, reason: 'You need access to at least one Building Passport first.' }
  }
  const requirement = workflow?.needs?.feature ? REQUIREMENTS[workflow.needs.feature] : null
  if (requirement && !requirement.check(state)) return { available: false, reason: requirement.reason }
  return { available: true, reason: null }
}
